import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { X } from 'react-feather'
import { orderHistoryData } from '../../../../../Data/AppsData/EcommerceData/OrderHistoryData'
import CommonCardHeader from '../../../../../Utils/CommonComponents/CommonCardHeader'
import { Btn, H6, Image } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Utils'
import { Href, InStock, Price } from '../../../../../Utils/Constants'

export default function OrderCards() {
    const [closedCards, setClosedCards] = useState<number[]>([]);
    const toggleCard = (index: number) => {
        setClosedCards((prevClosedCards) =>
            prevClosedCards.includes(index)
                ? prevClosedCards.filter((item) => item !== index)
                : [...prevClosedCards, index]
        );
    };
    const isCardClosed = (index: number) => closedCards.includes(index);
    return (
        <Col sm={12}>
            {orderHistoryData.map((item) => (
                <Card key={item.id}>
                    <CommonCardHeader title={item.heading} />
                    <CardBody>
                        <Row className="g-sm-4 g-3">
                            {item.details.map((product) => (
                                <Col xxl={4} md={6} key={product.id}>
                                    {!isCardClosed(product.id) && (
                                        <div className="prooduct-details-box">
                                            <div className="d-flex">
                                                <Image className="align-self-center img-fluid img-60" src={dynamicImage(`ecommerce/product-table-${product.image}`)} alt="#" />
                                                <div className="flex-grow-1 ms-3">
                                                    <div className="product-name">
                                                        <H6><a href={Href}>{product.name}</a></H6>
                                                    </div>
                                                    <div className="rating"><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i></div>
                                                    <div className="price d-flex">
                                                        <div className="text-muted me-2">{Price}</div>: {'210$'}
                                                    </div>
                                                    <div className="avaiabilty">
                                                        <div className="text-success">{InStock}</div>
                                                    </div>
                                                    <Btn color={product.color} size='xs'>{product.avaiabilty}</Btn>
                                                    <X className='close' onClick={() => toggleCard(product.id)} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>
            ))}
        </Col>
    )
}
